export default "__VITE_ASSET__BoJP_J3O__";